import React from 'react'
import PropTypes from 'prop-types'
import TextArea from '../../../../form/component/TextArea'
import ContentBox from '../../../../layout/component/ContentBox'
import currentUserHasAccess from '../../../../../util/widget-helper'
import { CUSTOMER_ADD_COMMENT } from '../../../ui-definition/customer-ui'
import Checkbox from '../../../../form/component/Checkbox'
import {lifecycle} from "recompose";

const infoStyle = {
    marginBottom: '20px',
    color: '#727272',
}

const checkboxStyle = {
    display: 'inline-flex',
    marginLeft: '25px',
    verticalAlign: 'bottom',
    marginBottom: '8px',
}

const iconStyle = {
    marginLeft: '8px',
    marginBottom: '14px',
    verticalAlign: 'bottom',
}

const NewProcessComment = ({ changeProcessComment, commentText, addProcessComment, isInternal, changeIsCommentInternal, currentUser }) => {
    if (!currentUserHasAccess(CUSTOMER_ADD_COMMENT)) {
        return null
    }

    const isEmployee = currentUser.roleList.includes('employee');

    return (
        <ContentBox title="Add New Comment">
            <div className="comment-post">
                {isEmployee && (
                    <div style={infoStyle}>
                        * Please be aware that your comment will be visible to everyone who uses our backend. If you want to make it visible to PlusDental employees only, please mark it as "internal comment". *
                    </div>
                )}
                <TextArea className="form-control comment-post-textarea"
                    object={{commentText}}
                    name="commentText"
                    onChange={changeProcessComment}
                    placeholder="Enter comment. Click button below to submit."/>
                <div>
                    <button
                        className="btn btn-primary"
                        disabled={!commentText}
                        onClick={addProcessComment}>
                        Save Comment
                    </button>
                    {isEmployee && [
                        <Checkbox
                            style={checkboxStyle}
                            onChange={changeIsCommentInternal}
                            name="isInternal"
                            object={{ isInternal }}>
                            Internal comment
                        </Checkbox>,
                        <i style={iconStyle} className="fa fa-lock fa-lg"></i>
                    ]}
                </div>
            </div>
        </ContentBox>
    )
}

NewProcessComment.propTypes = {
    changeProcessComment: PropTypes.func.isRequired,
    addProcessComment: PropTypes.func.isRequired,
    commentText: PropTypes.string,
    isInternal: PropTypes.bool,
    changeIsCommentInternal: PropTypes.func.isRequired,
    currentUser: PropTypes.object,
}

export default lifecycle({
    componentDidMount () {
        const { currentUser, changeIsCommentInternal } = this.props
        const isInternal = currentUser.roleList.includes('employee');
        changeIsCommentInternal(null, isInternal)
    },
})(NewProcessComment)



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/tab-comments/NewProcessComment.js